var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClickUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0391 67.0183L25.8419 57.9766C32.1127 66.1607 38.775 69.9331 46.1909 69.9331C53.567 69.9331 60.041 66.2054 66.0292 58.0856L78.0006 66.9093C69.3604 78.618 58.6233 84.8044 46.1909 84.8044C33.7981 84.8044 22.9569 78.6576 14.0391 67.0183Z",
    fill: "url(#paint0_linear_5972_11583)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1567 27.7167L25.1485 45.82L15.4375 34.5575L46.2013 8.04688L76.7222 34.5773L66.9666 45.8002L46.1567 27.7167Z",
    fill: "url(#paint1_linear_5972_11583)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5972_11583",
    x1: 14.0391,
    y1: 1882.54,
    x2: 78.0006,
    y2: 1882.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8930FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49CCF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5972_11583",
    x1: 15.4375,
    y1: 2577,
    x2: 76.7222,
    y2: 2577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF02F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickUp);
export default __webpack_public_path__ + "static/media/click-up.2c0ac9a6c91d520b099bd5fb4910e3e3.svg";
export { ForwardRef as ReactComponent };